import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalCommand.ConversationTelemetry'

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Debug · {count} events',
  },
})
